import { defineComponent as _defineComponent } from 'vue'
import { isExternal } from '@/utils/validate'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    iconClass: null,
    className: null
  },
  setup(__props: any) {

const props = __props as {
  iconClass: string
  className?: string
}


const checkIsExternal = computed(() => {
  return isExternal(props.iconClass)
})
const iconName = computed(() => {
  return `#icon-${props.iconClass}`
})
const svgClass = computed(() => {
  if (props.className) {
    return 'svg-icon ' + props.className
  } else {
    return 'svg-icon'
  }
})
const styleExternalIcon = computed(() => {
  return {
    mask: `url(${props.iconClass}) no-repeat 50% 50%`,
    '-webkit-mask': `url(${props.iconClass}) no-repeat 50% 50%`
  }
})

return { __sfc: true,props, checkIsExternal, iconName, svgClass, styleExternalIcon }
}

})